const style = {
  display: "flex",
  flexDirection: "column",
  gap: 6,
  flexGrow: 1
};

export function HorizontalSettingContainer(props) {
  return (<>
    <div style={ style }>{ props.children }</div>
  </>);
}
